import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { prepareAgentExperience } from './prepareAgentExperience';

export function getAgentExperience({ experience }: IAgentSchema) {
  const preparedExperience = prepareAgentExperience(experience);

  return preparedExperience ? `Опыт работы ${preparedExperience}` : null;
}
